export const getIP = async () => {
  try {
    const response = await fetch('https://ipinfo.io?token=b791add97d2e69', {
      method: 'GET'
    });
    const responseJSON = await response.json();
    return responseJSON;
  } catch (e) {
    return { error: 'SERVER_ERROR' }
  }
};